import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const VendorCleaners =(AuthDataCharts,AuthStr) => {

     const getUrl = environmentConfig();
     const requestUrl = getUrl+ ConstantsBase.VendorCleaners

     try {
      const data =  axios({
        method: 'post',
        url: requestUrl,
        data: AuthDataCharts,
        headers: { 'Content-Type': 'application/json;' , Authorization: AuthStr },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
     }
     catch (e) {
      return e;
    }
}